import * as FwDatas from "../../FwDatas.ts";
import * as Storage from "../../lib/Storage.ts"
import * as Html from "../../util/Html.ts"
import { TaskCategoryBean } from "../fizapilib.auto.ts";

const closedById: Record<string, boolean> = JSON.parse(Storage.localGet('categoryState')||"{}")

// Augmentation of the generated bean with the properties added dynamically below
declare module "../fizapilib.auto.ts" {
  interface TaskCategoryBean {
    /** whether the category is expanded in the list, transient and persisted in the local storage */
    isOpen?: () => boolean;
  }
}

Html.registerDom({
  tooglecategory(): void {
    const
      metaId = Html.getDomMetaId(this),
      open = closedById[metaId]===false;

    this.parentElement?.classList.toggle('fw-open',open)
    closedById[metaId] = open;
    Storage.localSet('categoryState',JSON.stringify(closedById))
  }
})

Object.assign(TaskCategoryBean.prototype,{
  onDecode(this: TaskCategoryBean): void {
    FwDatas.cache(this);
    if(this.emoji===undefined){
      this.emoji = '🏷️'
    }
    this.isOpen = (): boolean => {
      return closedById[this.metaId]!==false;
    }
  },

})
